

















































































import {mapActions, mapGetters} from 'vuex';
import profilePicture from '@/components/profile/ProfilePicture.vue';
import Vue from 'vue';
import {emptyAuthor} from '@/store/modules/Profile/state';
import {AuthorProfile} from '#/User';
import RichTextEditor from '@/components/admin/RichTextEditor.vue';

interface ComponentData {
  dialog: { display: boolean };
  hasPictureLoaded: boolean;
  errorMessage: string;
  onLoad: boolean;
  user: AuthorProfile;
  userMessage: string;
  userMessageDialog: { display: boolean };
}

export default Vue.extend({
  name: 'AuthorDetail',

  components: {
    RichTextEditor,
    profilePicture,
  },

  data: (): ComponentData => ({
    dialog: {display: false},
    hasPictureLoaded: false,
    errorMessage: '',
    onLoad: true,
    user: emptyAuthor(),
    userMessage: '',
    userMessageDialog: {display: false},
  }),

  computed: {
    ...mapGetters([
      'authorProfile',
      'isAdmin',
      'hasSyncAction',
      'profile',
    ]),
    descriptionShow(): boolean {
      return !!this.user.description && !!this.user.description.trim();
    },
    cantBlacklist(): boolean {
      return this.user.isAdmin || this.user.id === this.profile.id;
    },
  },

  created() {
    this.loadAuthorProfile({id: parseInt(this.$route.params.authorId)})
        .then(() => {
          this.user = this.authorProfile;
          this.updatePageTitle(this.user.name);
          this.hasPictureLoaded = !!this.user.profilePhoto;
          this.onLoad = false;
        });
  },

  methods: {
    ...mapActions([
      'blacklistToggle',
      'displaySnackBar',
      'loadAuthorProfile',
      'sendUserMessage',
      'updatePageTitle',
    ]),
    onBlacklist(): void {
      this.blacklistToggle({blacklist: !this.user.censured, user: this.user})
          .then(() => {
            this.user.censured = !this.user.censured;
          });

    },
    onQueryAdverts(): void {
      this.$router.push({name: 'AdvertList', query: {author__id: `${this.user.id}`}});
    },
    onSendMessage(): void {
      if (this.userMessage !== '') {
        this.sendUserMessage({
          adminId: this.profile.id,
          authorId: this.authorProfile.id,
          message: this.userMessage,
        })
            .then(() => {
              this.userMessage = '';
              this.userMessageDialog.display = false;

              this.displaySnackBar({
                text: this.$t('profile.author.sendMessage.sent'),
                type: 'information',
              });
            });
      } else {
        this.errorMessage = this.$t('admin.message.error') as string;
      }
    },
    onUserMessageDialogCancel(): void {
      this.errorMessage = '';
      this.userMessageDialog.display = false;
      this.userMessage = '';
    },
  },
});
